import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./SplitViewHtml.module.scss";
import { LinkType } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { Links } from "../Links/Links";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers } from "../Paragraph/Citation";
import parse from "html-react-parser";
export const SplitViewHtml: React.FC<{
  title: string;
  swapped?: boolean;
  rowSwapped?: boolean;
  darktext?: boolean;
  paragraph: any[];
  links: (LinkType | NavLink)[];
  code: string;
}> = t0 => {
  const $ = _c(24);
  const {
    title,
    swapped,
    rowSwapped,
    darktext,
    paragraph,
    links,
    code
  } = t0;
  let classes;
  if ($[0] !== darktext || $[1] !== rowSwapped || $[2] !== swapped) {
    classes = [styles.splitview];
    if (swapped) {
      classes.push(styles.swapped);
    }
    if (rowSwapped) {
      classes.push(styles.rowSwapped);
    }
    if (darktext) {
      classes.push(styles.darktext);
    }
    $[0] = darktext;
    $[1] = rowSwapped;
    $[2] = swapped;
    $[3] = classes;
  } else {
    classes = $[3];
  }
  const t1 = classes.join(" ");
  let t2;
  if ($[4] !== title) {
    t2 = <h4>{title}</h4>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== paragraph) {
    t3 = <PortableText value={paragraph} components={customComponentRenderers} />;
    $[6] = paragraph;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== links) {
    t5 = links && <Links links={links} />;
    $[11] = links;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className={styles.splitviewtext}>{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== code) {
    t7 = parse(code);
    $[16] = code;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <div className={styles.splitviewcode}><div>{t7}</div></div>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t1 || $[21] !== t6 || $[22] !== t8) {
    t9 = <div className={t1}>{t6}{t8}</div>;
    $[20] = t1;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};